import { render, staticRenderFns } from "./publies.vue?vue&type=template&id=2c7e09b6"
import script from "./publies.vue?vue&type=script&lang=js"
export * from "./publies.vue?vue&type=script&lang=js"
import style0 from "./publies.vue?vue&type=style&index=0&id=2c7e09b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports